<template>
  <div class="box" v-if="downloadVisable">
    <el-dialog :visible.sync="downloadVisable" width="30%" :before-close="handleClose" :show-close="false">
      <div class="img">
        <div class="bgImg">
          <img src="../../static/下载弹窗插图.png" alt="" />
        </div>
      </div>
      <div class="closeIcon" @click="close">
        <i class="el-icon-close"></i>
      </div>
      <div class="tip">{{ $t('message.isDownload') }}</div>

      <div class="title">{{ ' “ ' + title + ' ”' }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadFile">{{ $t('common.download') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      msg: this.downloadVisable,
      cancel: true,
      fileTitle: this.title,
    };
  },
  props: ['title', 'downloadVisable'],
  methods: {
    handleClose() {
      this.msg = false;
      this.$emit('downCancel', this.msg);
    },
    downloadFile() {
      this.msg = false;
      this.$emit('downFile', this.msg);
    },
    close() {
      this.msg = false;
      this.$emit('downCancel', this.msg);
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  width: 100%;
  height: 88.1vw;
  position: relative;
  .img {
    width: 100%;
    position: relative;
    height: 37.3vw;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 187, 41, 0.1) 100%);

    .bgImg {
      padding-left: 8vw;
      padding-right: 8vw;
      box-sizing: border-box;
      width: 71.1vw;
      height: 62.53vw;
      margin: 0 auto;
      justify-content: center;
      align-items: center;
      display: flex;

      img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
  }
  .closeIcon {
    position: absolute;
    top: 2.6vw;
    right: 5vw;
    width: 2.93vw;
    height: 2.93vw;
  }
  .tip {
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    font-size: 4.8vw;
    margin-top: 8vw;
  }
  .title {
    font-size: 4.3vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #006fb8;
    margin-top: 4vw;
  }
}
</style>
<style scoped lang="scss">
.el-dialog {
  text-align: center;
}
.el-dialog__wrapper {
  top: 20vw;
}
</style>
<style scoped>
.el-dialog__wrapper >>> .el-dialog__footer {
  text-align: center;
  margin-top: 10.67vw;
  padding: 0;
  box-sizing: border-box;
}
.dialog-footer >>> .el-button--primary {
  width: 28.8vw;
  height: 9.6vw;
  background: #006fb8;
  border-radius: 1vw;
}
.el-dialog__wrapper >>> .el-dialog {
  width: 87% !important;
  height: 88.1vw;
  background: #ffffff;
}
.el-dialog__wrapper >>> .el-icon-close {
  color: #312c2b;
  font-size: 5vw !important;
}
.el-dialog__wrapper >>> .el-dialog__body {
  padding: 0;
  box-sizing: border-box;
  text-align: center;
  height: 71%;
}
.el-dialog__wrapper >>> .el-dialog__header {
  padding: 0;
  box-sizing: border-box;
}
</style>
